module.exports = __webpack_public_path__ + "static/media/ic_language.e7e41f68.svg";